<template>
  <div v-show="true" :class="getClassName">
    <input
      v-for="(item, index) in getChangeOptionsHiddenInputs"
      :key="index"
      type="hidden"
      :name="index"
      :value="item"
    />
    <input
      v-for="(item, index) in getHiddenInputsWithIds"
      :id="item.id"
      :key="index"
      type="hidden"
      :name="item.name"
      :value="item.value"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { useWebproductStore } from "@/stores/modules/webproduct";

export default {
  computed: {
    ...mapState(useChangeOptionsStore, ["getChangeOptionsHiddenInputs"]),
    ...mapState(useWebproductStore, [
      "getIsPersonalizationNewPage",
      "getWebProductTemplate"
    ]),
    getHiddenInputsWithIds: function () {
      let result = {};
      if (!this.getIsPersonalizationNewPage) {
        result = {
          templateId: {
            id: "templateId",
            name: "templateId",
            value: this.getWebProductTemplate
          }
        };
      }
      return result;
    }
  }
};
</script>
